module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-05"
  }, [_vm._v("ORGANIZATION OF THE DEPARTMENT OF BLISS (1998)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Department of Bliss (DOB)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Director (DIROB)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Headquarters Staff")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Prosperity Section (PROSEC)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Deputy Director (DEPDIRPRO)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Wisdom Section (WISSEC)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Deputy Director (DEPDIRWIS)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Vigor Section (VIGSEC)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Deputy Director (DEPDIRVIG)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Culture Section (CULSEC)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Deputy Director (DEPDIRCUL)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Satisfaction Section (SATSEC)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Deputy Director (DEPDIRSAT)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_vm._v("ORGANIZATION OF SATISFACTION SECTION, DOB")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Satisfaction Section (SATSEC)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Deputy Director (DEPDIRSAT)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Headquarters Staff")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Division of Research & Development (DIVRAD)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Assistant Deputy Director (AssDepDirRad)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Division of Security & Intelligence (DIVSEC)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Assistant Deputy Director (AssDepDirSec)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Division of Data & Statistics (DIVDAT)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Assistant Deputy Director (AssDepDirDat)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-04"
  }, [_vm._v("Division of Law & Enforcement (DIVLAW)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Assistant Deputy Director (AssDepDirLaw)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4968b930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter02.vue
// module id = 81
// module chunks = 0